import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorModule } from 'primeng/paginator';
import { TableModule } from 'primeng/table';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CheckboxModule } from 'primeng/checkbox';
import { FormlyModule } from '@ngx-formly/core';
import {
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef
} from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { TagModule } from 'primeng/tag';
import { ProgressBarModule } from 'primeng/progressbar';
import { FormlyPrimeNGModule } from '@ngx-formly/primeng';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { AvatarModule } from 'primeng/avatar';
import { CalendarModule } from 'primeng/calendar';
import { BadgeModule } from 'primeng/badge';
import { FileUploadModule } from 'primeng/fileupload';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputSwitchModule } from 'primeng/inputswitch';

import { TabViewModule } from 'primeng/tabview';
import { MessageModule } from 'primeng/message';
import { FullCalendarModule } from '@fullcalendar/angular';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { CardModule } from 'primeng/card';
import { MultiSelectModule } from 'primeng/multiselect';
import { ApproveConfirmComponent } from './components/approve-confirm/approve-confirm.component';
import { DeleteConfirmComponent } from './components/delete-confirm/delete-confirm.component';
import { InviteModalComponent } from './components/invite-modal/invite-modal.component';
import { ManageUserRolesComponent } from './components/manage-user-roles/manage-user-roles.component';
import { MapEsriComponent } from './components/map/map-esri/map-esri.component';
import { SearchFilterPipe } from './pipes/search/search-filter.pipe';
import { DeleteConfirmDialogComponent } from './components/delete-confirm-dialog/deleteConfirmDialog.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { ChipModule } from 'primeng/chip';
import { AvatarGeneratorComponent } from './components/avatar-generator/avatar-generator.component';
import { LicenseSubscriptionCheckComponent } from '../license/components/license-subscription-check/license-subscription-check.component';
import { LicenseNotSubscribedViewComponent } from '../license/components/license-not-subscribed-view/license-not-subscribed-view.component';
@NgModule({
  declarations: [
    ConfirmDialogComponent,
    DeleteConfirmDialogComponent,
    DeleteConfirmComponent,
    ManageUserRolesComponent,
    SearchFilterPipe,
    InviteModalComponent,
    MapEsriComponent,
    ApproveConfirmComponent
  ],
  exports: [
    SearchFilterPipe,
    MapEsriComponent,
    DeleteConfirmDialogComponent,
    ConfirmDialogComponent
  ],
  providers: [DynamicDialogRef, DynamicDialogConfig],
  imports: [
    CommonModule,
    FileUploadModule,
    TableModule,
    MessageModule,
    TagModule,
    PaginatorModule,
    FormsModule,
    CardModule,
    ReactiveFormsModule,
    RouterModule,
    CheckboxModule,
    CalendarModule,
    BadgeModule,
    InputSwitchModule,
    FormlyModule,
    FormlyPrimeNGModule,
    ButtonModule,
    DynamicDialogModule,
    TabViewModule,
    InputTextModule,
    ProgressBarModule,
    AvatarModule,
    DialogModule,
    SplitButtonModule,
    FormsModule,
    FullCalendarModule,
    DialogModule,
    InputTextareaModule,
    ButtonModule,
    CalendarModule,
    DropdownModule,
    ToastModule,
    RippleModule,
    MultiSelectModule,
    ChipModule,
    AvatarGeneratorComponent,
    LicenseSubscriptionCheckComponent,
    LicenseNotSubscribedViewComponent
  ]
})
export class SharedModule {}
